export enum LifeCycle {
  NEW = 'new',
  END_OF_LIFE = 'end_of_life',
  STOPPED = 'stopped',
  CATEGORY_A = 'category_a',
  CATEGORY_B = 'category_b',
  CATEGORY_C = 'category_c',
}

export const LifeCycleTranslations: Record<LifeCycle, string> = {
  [LifeCycle.NEW]: 'Nouveauté',
  [LifeCycle.END_OF_LIFE]: 'Fin de vie',
  [LifeCycle.STOPPED]: 'Arrêté',
  [LifeCycle.CATEGORY_A]: 'Catégorie A',
  [LifeCycle.CATEGORY_B]: 'Catégorie B',
  [LifeCycle.CATEGORY_C]: 'Catégorie C',
};

export const LifeCycleSelects = (Object.keys(LifeCycleTranslations) as unknown as LifeCycle[]).map((lifeCycle) => ({
  value: lifeCycle,
  label: LifeCycleTranslations[lifeCycle],
}));
